import { all, put, takeLatest, call } from 'redux-saga/effects';
import { DashboardActionTypes } from 'types';
import {
  getDashboardEnquirerStatsSuccess,
  getDashboardEnquirerStatsFailure,
  getDashboardAssetOwnerStatsSuccess,
  getDashboardAssetOwnerStatsFailure,
  getDashboardDBYDStatsSuccess,
  getDashboardDBYDStatsFailure
} from './actions';
import {
  getDashboardEnquirerStats,
  getDashboardAssetOnwerStats,
  getDashboardDBYDAdminStats
} from 'services/dashboard.service';

function* handleDashboardEnquirerStats(request: any) {
  try {
    const { params } = request.payload;
    const response = yield getDashboardEnquirerStats(params);
    if (response.error) {
      return yield put(
        getDashboardEnquirerStatsFailure(response.error.message)
      );
    }
    yield put(getDashboardEnquirerStatsSuccess(response));
  } catch (err) {
    const errMsg = err?.response?.data?.error?.message || err?.toString();
    yield put(getDashboardEnquirerStatsFailure(errMsg));
  }
}

function* handleDashboardAssetOwnerStats(request: any) {
  try {
    const { params } = request.payload;
    const response = yield getDashboardAssetOnwerStats(params);
    if (response.error) {
      return yield put(
        getDashboardAssetOwnerStatsFailure(response.error.message)
      );
    }
    yield put(getDashboardAssetOwnerStatsSuccess(response));
  } catch (err) {
    const errMsg = err?.response?.data?.error?.message || err?.toString();
    yield put(getDashboardAssetOwnerStatsFailure(errMsg));
  }
}

function* handleDashboardDBYDStats(request: any) {
  try {
    const { params } = request.payload;
    const response = yield getDashboardDBYDAdminStats(params);
    if (response?.error) {
      return yield put(getDashboardDBYDStatsFailure(response.error.message));
    }
    yield put(getDashboardDBYDStatsSuccess(response));
  } catch (err) {
    const errMsg = err?.response?.data?.error?.message || err?.toString();
    yield put(getDashboardDBYDStatsFailure(errMsg));
  }
}

function* watchDashboardEnquirerStats() {
  yield takeLatest(
    DashboardActionTypes.GET_DASHBOARD_ENQUIRER_STATS_START,
    handleDashboardEnquirerStats
  );
}

function* watchDashboardAssetOwnerStats() {
  yield takeLatest(
    DashboardActionTypes.GET_DASHBOARD_ASSETONWER_STATS_START,
    handleDashboardAssetOwnerStats
  );
}

function* watchDashboardDBYDStats() {
  yield takeLatest(
    DashboardActionTypes.GET_DASHBOARD_DBYD_STATS_START,
    handleDashboardDBYDStats
  );
}

function* dashboardSagas() {
  yield all([
    call(watchDashboardEnquirerStats),
    call(watchDashboardAssetOwnerStats),
    call(watchDashboardDBYDStats)
  ]);
}

export default dashboardSagas;
